module.exports = __webpack_public_path__ + "./fonts/bootstrap-icons.woff";